import employeeModalTemplate from 'modals/employeesSearch/index.html';
import EmployeeModalController from 'modals/employeesSearch';

export default function($log, $q, $stateParams, $uibModal, ApiClass) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  vm.sortableOptions = {
    connectWith: '.connectList'
  };

  vm.assign = profile_uid => {
    ApiClass.activitiesIdTypePut(
      { id: $stateParams.activity_id, type: 'assigned' },
      { profile_uids: [profile_uid] },
      { queryParams: { manage: true } }
    ).then(() => {
      vm.callback();
    });
  };

  vm.selectEmployees = () => {
    //const filterEmployees = vm.users.map(({ email }) => email);
    $uibModal
      .open({
        backdrop: 'static',
        animation: true,
        size: 'lg',
        template: employeeModalTemplate,
        controller: EmployeeModalController(undefined, undefined, undefined, true),
        controllerAs: 'employeeModalCtrl'
      })
      .result.then(users => {
        return ApiClass.activitiesIdTypePut(
          { id: $stateParams.activity_id, type: 'assigned' },
          { profile_uids: users.map(({ profile_uid }) => profile_uid) },
          { queryParams: { manage: true } }
        );
      })
      .then(() => {
        swal('Success', 'The selected employees have been added to this activity', 'info');
        vm.callback();
      })
      .catch(error => {
        if (error === 'backdrop click' || error === 'cancel') return;
        $log.error(error);
        throw error;
      });
  };

  vm.remove = profile_uid => {
    ApiClass.activitiesIdTypeTypeIdDelete(
      { id: $stateParams.activity_id, type: 'assigned', type_id: profile_uid },
      {},
      { queryParams: { manage: true } }
    )
      .then(() => {
        vm.callback();
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  };

  vm.removeSelected = () => {
    vm.laddaBtnRemove = true;
    const qArr = vm.selectedUsers.map(({ profile_uid }) =>
      ApiClass.activitiesIdTypeTypeIdDelete(
        { id: $stateParams.activity_id, type: 'assigned', type_id: profile_uid },
        {},
        { queryParams: { manage: true } }
      )
    );

    $q.all(qArr)
      .then(() => {
        vm.laddaBtnRemove = false;
        vm.callback();
      })
      .catch(error => {
        vm.laddaBtnRemove = false;
        $log.error(error);
        throw error;
      });
  };

  vm.userSelect = () => filterSelectedUsers();

  vm.selectAll = select => {
    vm.users.forEach(user => (user.selected = select));
    filterSelectedUsers();
  };

  function filterSelectedUsers() {
    vm.selectedUsers = angular.copy(vm.users).filter(({ selected }) => selected);
  }

  function activate() {
    $log.debug('Activities assigned component activated.');

    vm.profile_uid = $stateParams.id;
    vm.selectedUsers = [];
  }
}



// WEBPACK FOOTER //
// ./src/app/components/activities/activityUsers/controller.js